import { useMdfOverviewMetrics } from '../../hooks/useMdfOverviewMetrics'

import {
  ActivityOutcomesCard,
  ContraOverviewCard,
  LinkageOverviewCard,
  PaidOverviewCard,
  PlannedOverviewCard,
  RequestedOverviewCard,
} from './components'

import styles from './MdfAggregatedOverview.module.scss'

interface IMdfAggregatedOverviewProps {
  onUnlinkedClick: () => void
  onProvideOutcomeClick: () => void
}

export const MdfAggregatedOverview = ({
  onUnlinkedClick,
  onProvideOutcomeClick,
}: IMdfAggregatedOverviewProps) => {
  const { metrics, totalPlanned, contraMetrics, isUsd, activeCurrency } = useMdfOverviewMetrics()

  return (
    <div className={styles.root}>
      <LinkageOverviewCard
        total={metrics.total}
        linked={metrics.linked}
        unlinked={metrics.unlinked}
        onUnlinkedClick={onUnlinkedClick}
      />
      <PlannedOverviewCard
        totalPlanned={totalPlanned}
        isUsd={isUsd}
        activeCurrency={activeCurrency}
      />
      <RequestedOverviewCard
        totalRequested={metrics.totalRequested}
        isUsd={isUsd}
        activeCurrency={activeCurrency}
      />
      <PaidOverviewCard
        totalPaid={metrics.totalPaid}
        percentPaid={metrics.percentPaid}
        isUsd={isUsd}
        activeCurrency={activeCurrency}
      />
      <ContraOverviewCard {...contraMetrics} />
      <ActivityOutcomesCard
        executedCount={metrics.executedCount}
        outcomeProvidedCount={metrics.outcomeProvidedCount}
        onProvideOutcomeClick={onProvideOutcomeClick}
      />
    </div>
  )
}

MdfAggregatedOverview.displayName = 'MdfAggregatedOverview'
